import { FC, useState } from 'react'
import tw from 'twin.macro'
import { Link } from 'gatsby'
import { Body, Grid, SubHeader } from './UI'
import InlineSvg from 'react-inlinesvg'
import { useForm } from 'react-hook-form'
import { SocialMediaLinks } from '../types/prismic'

import logo from '../images/gabbi-logo-white-r.png'
import ctaArrow from '../images/icons/cta-arrow.svg'

type Props = {
  socialMediaLinks: SocialMediaLinks
}

type SubmitData = { email: string }

const Footer: FC<Props> = ({ socialMediaLinks }) => {
  const [formSubmitted, setFormSubmitted] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const onSubmit = (data: SubmitData) => {
    const formData = new FormData()
    formData.append('email', data.email)

    fetch('https://getform.io/f/9e92ab81-da9a-4e15-b137-30394c3635cb', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (response.ok) setFormSubmitted(true)
      })
      .catch((error) => console.log(error))
  }

  return (
    <section tw="bg-gb-red pt-[64px] pb-[32px] text-white font-domaine lg:(pt-[96px] pb-[54px])">
      <Grid>
        <div tw="col-span-full mb-[30px] lg:(col-span-3 mb-0)">
          <h2 css={[SubHeader, tw`text-[28px] mb-5`]}>Keep in touch</h2>
          <form
            onSubmit={handleSubmit(onSubmit)}
            css={[formSubmitted && tw`hidden`]}
          >
            <div tw="relative flex items-center justify-between border-b border-white w-full mb-2">
              <input
                css={[
                  Body,
                  tw`py-2 flex-grow bg-transparent placeholder:(text-white) focus:(outline-none)`,
                ]}
                id="email-input"
                name="Email"
                placeholder="your email"
                {...register('email', {
                  required: true,
                  pattern:
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                })}
              />
              <div tw="relative flex items-center h-9">
                <InlineSvg src={ctaArrow} tw="w-6 text-white" />
                <input
                  type="submit"
                  value=""
                  tw="absolute w-full h-full top-0 opacity-0 cursor-pointer"
                />
              </div>
            </div>
            {/* errors will return when field validation fails  */}
            {errors.email && (
              <span css={[Body, tw`text-gb-blue font-normal`]}>
                This field is required
              </span>
            )}
          </form>
          {/* Form success message */}
          <div
            css={[
              tw`hidden py-2.5 text-white`,
              formSubmitted && tw`block mb-[1px]`,
            ]}
          >
            Thank you!
          </div>
        </div>
        <div tw="col-start-1 col-span-2 mb-[30px] lg:(col-start-8 col-span-2 mb-0)">
          <Link to="/team" tw="block mb-[13px]">
            Team and Careers
          </Link>
          <Link to="/#press" tw="block mb-[13px]">
            Press
          </Link>
        </div>
        <div tw="col-span-full lg:(col-start-10 col-span-3)">
          <div tw="mb-[13px]">
            <a href="mailto:hello@gabbi.com">
              Contact Us
              <InlineSvg src={ctaArrow} tw="w-6 mx-2 mt-[-2px] inline" />
              hello@gabbi.com
            </a>
          </div>
          {socialMediaLinks.map((item, index) => (
            <a
              key={`social-media-${index}`}
              href={item.link && 'url' in item.link && item.link.url}
              target="_blank"
              rel="noopener noreferrer"
              tw="block mb-[13px]"
            >
              {item.platform}
            </a>
          ))}
        </div>
        <div tw="col-span-full flex items-center justify-between mt-[117px] lg:(col-span-full flex items-end mt-[153px] justify-start)">
          <Link to="/">
            <img src={logo} tw="w-[148px] lg:w-[163px]" alt="" />
          </Link>
          <div tw="ml-16">
            <Link to="/privacy" tw="mb-0 lg:(mb-[10px] inline-block)">
              Privacy
            </Link>
            <Link to="/terms" tw="mb-0 ml-6 lg:(mb-[10px] inline-block)">
              Terms
            </Link>
            <Link to="/npp" tw="mb-0 ml-6 lg:(mb-[10px] inline-block)">
              HIPAA Notice of Privacy Practices
            </Link>
          </div>
        </div>
      </Grid>
    </section>
  )
}

export default Footer
